import React from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import InstagramToken from './instagram/token';
import FacebookToken from './facebook/token';
import Services from './services';
import logo from '../images/dsplay-logo.png';

function Home() {

  const { t } = useTranslation();

  return (
    <div className="home">
      <div className="line-bg" />
      <header>
        <a href="https://dsplay.tv">
          <img alt="DSPLAY" src={logo} style={{ height: 70 }} />
        </a>
      </header>
      <div className="title">
        <Link to="/">{t('Token Generator')}</Link>
      </div>
      <div className="card">
        <Switch>
          <Route path="/instagram">
            <InstagramToken />
          </Route>
          <Route path="/facebook">
            <FacebookToken />
          </Route>
          <Route path="/">
            <Services />
          </Route>
        </Switch>
      </div>
      <footer>
        Copyright &copy; 2012-{new Date().getFullYear()} DSPLAY - Digital Signage
      </footer>
    </div>
  );
}

export default Home;